import {Box, Center, Stack} from '@chakra-ui/react';
import StartAnimation from './components/organisms/StartAnimation';
import './global.css'
import HomePage from './pages/HomePage';

const App = () => {
  return (
    <div className="App">
      <HomePage/>
    </div>
  );
}

export default App;
